import Client from "./Clients/ScrapingToolsClient";
import RepoUtils from './RepoUtils'

const resource = '/operations/location_report/'
const tableResource = '/operations/location_report/table/'

const manualImportResource = '/operations/job_log/manual_import/'

const runReportOperationResource='/operations/location_report/run_operation/'
const reportProcessResource='/operations/location_report/status/'
const reportProcessResultsResource='/operations/location_report/results/'

export default {
    get(){
        return Client.get(resource);
    },
    getWithId(id){
        return Client.get(`${resource}?id=${id}`)
    },
    getTable(pageNumber,filters){
        filters.page=pageNumber;
        return Client.get(RepoUtils.parseResourceWithQueryParams(tableResource,filters));
    },
    post(payload){
        return Client.post(resource,payload)
    },
    put(id,payload){
        return Client.put(`${resource}${id}/`,payload)
    },
    manualImport(payload,reportId){
        return Client.post(manualImportResource+reportId+'/',payload,{headers:{'Content-Type':'text/csv'}})
    },
    runReportOperation(payload){
        return Client.post(runReportOperationResource,payload);
    },
    getReportProcesses(){
        return Client.get(reportProcessResource);
    },
    getReportProcessResults(processUUID){
        return Client.get(reportProcessResultsResource+processUUID+'/',{responseType:'blob'})
    }
}